const DOWNLOAD_RESULT_I18N_KEYS = {
  Generated: 'downloadLogUi.generated',
  'download file create error': 'downloadLogUi.createError',
}

export function formatDownloadResult (vm, result) {
  if (result == null || result === '') {
    return result
  }
  const key = DOWNLOAD_RESULT_I18N_KEYS[result]
  return key ? vm.$t(key) : result
}
